import styled from 'foundations-theming/utils';
export const ShinySkeletonCircle = styled.div.attrs(({
  size
}) => ({
  ['data-loading']: 'true',
  size
})).withConfig({
  displayName: "ShinySkeletonCircle",
  componentId: "sc-2wz3ap-0"
})(["background:", ";background:", ";background-size:1200px;background-color:", ";border-radius:50%;height:", "px;width:", "px;"], ({
  theme
}) => theme.color['fill-tertiary-pressed'], ({
  theme
}) => `linear-gradient(
    to right,
    ${theme.color['fill-tertiary-pressed']},
    ${theme.color['fill-primary-disabled']} 20%,
    ${theme.color['fill-tertiary-pressed']} 40%
  )`, ({
  theme
}) => theme.color['fill-primary-disabled'], ({
  size
}) => size, ({
  size
}) => size);